import { ActionTree } from 'vuex'
import { RootState, UserState } from '@/store/storeTypes'
import AuthApi from '@/ts/apis/AuthApi'

const actions: ActionTree<UserState, RootState> = {
  init: async ({ commit, state, dispatch }) => {
    if (state.uid !== null) {
      return false
    }
    commit('setInprogress')
    const user = await AuthApi.loginAnonimouse()
    console.log('login user =', user)
    if (user) {
      commit('setLoggedin', { uid: AuthApi.uid, isAuthed: !user.isAnonymous })
      dispatch('doc/listDocs', {}, { root: true })
      return true
    }
    return false
  },
  snsLinkup: async ({ commit, state }) => {
    if (state.authorized) {
      console.log('already authorized')
      return false
    }
    if (state.uid === null) {
      console.warn('No uid')
      return false
    }
    commit('setInprogress')
    await AuthApi.linkWithTwitter()
    return true
  },
  snsLoginWithoutAnon: async ({ commit, state }) => {
    if (state.authorized) {
      console.log('already authorized')
      return false
    }
    commit('setInprogress')
    await AuthApi.logoutThenLoginWithTwitter()
    return true
  }
}

export default actions
